/** Checks for the presence of a protocol (http or https) in the URL string and adds it if it is missing */
export function ensureProtocol(url: string) {
  // Checking include "http://", "https://", "tel:" or "mailto:"
  if (!/^(https?:\/\/|tel:|mailto:)/i.test(url)) {
    url = 'https://' + url;
  }

  return url;
}
